export default "__VITE_ASSET__CG6MWGjD__"